import { render, staticRenderFns } from "./SessionPage.vue?vue&type=template&id=54ed8802&"
import script from "./SessionPage.vue?vue&type=script&lang=ts&"
export * from "./SessionPage.vue?vue&type=script&lang=ts&"
import style0 from "./SessionPage.vue?vue&type=style&index=0&id=54ed8802&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports